import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Type, WorkOrderCase, WorkOrderLabour, WorkOrderRequestSub } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map, switchMap } from 'rxjs/operators';
import {
  CreateWorkOrderCaseOnServer,
  CreateWorkOrderCaseOnServerSuccess,
  DeleteWorkOrderCaseFromServer,
  DeleteWorkOrderCaseFromServerSuccess,
  WorkOrderCasesEntityActionTypes,
} from './work-order-cases.actions';

@Injectable()
export class WorkOrderCasesEntityEffects {
  createWorkOrderCaseOnServer = createEffect(() =>
    this.dataPersistence.fetch(WorkOrderCasesEntityActionTypes.CreateWorkOrderCaseOnServer, {
      run: (action: CreateWorkOrderCaseOnServer, state: any) => {
        return this.apiService
          .post<WorkOrderCase>(
            `v/1/fixed-operations/work-orders/${action.payload.workOrderCase.workOrderId}/cases`,
            action.payload.workOrderCase
          )
          .pipe(
            switchMap((workOrderCase) => {
              let workOrderRequestSub = new WorkOrderRequestSub();
              workOrderRequestSub.workOrderId = workOrderCase.workOrderId;
              if (action.payload.workOrderCase.warrantySubmissionTypeId == 'WC') {
                workOrderRequestSub.submitFlag = '1';
              } else {
                workOrderRequestSub.submitFlag = '0';
              }

              workOrderRequestSub.workOrderSequence = workOrderCase.sequence;
              workOrderRequestSub.warrantySubmissionTypeId = workOrderCase.warrantySubmissionTypeId;
              workOrderRequestSub.labourCode = workOrderCase.labourOp;
              return this.apiService
                .post<WorkOrderRequestSub>(
                  `v/1/fixed-operations/work-orders/${action.payload.workOrderCase.workOrderId}/request-subs`,
                  workOrderRequestSub
                )
                .pipe(
                  switchMap((workOrderRequestSub) => {
                    return this.apiService
                      .get<Type>(`v/1/vehicles/vehicle-types/${action.payload.vehicle.typeId}`)
                      .pipe(
                        switchMap((vehType: Type) => {
                          return this.apiService
                            .get<WorkOrderRequestSub>(
                              `v/1/fixed-operations/work-orders/${action.payload.workOrderCase.workOrderId}/workflow/labourRate`,
                              {
                                params: {
                                  vehicleClassId: vehType.classId,
                                  rooftopId: action.payload.vehicle.rooftopId,
                                  defaultFlag: 1,
                                  windowTypeId: 'L',
                                },
                              }
                            )
                            .pipe(
                              switchMap((labourRate) => {
                                let workOrderLabour = new WorkOrderLabour();

                                let serviceGroupRate = action.payload?.servicePricing?.serviceGroup?.serviceGroupRate;
                                let serviceTotals = action.payload?.servicePricing?.serviceTotals;
                                let taxData = action.payload?.servicePricing?.taxData;

                                //let serviceGroupRate = action.payload?.serviceGroup?.serviceGroupRate;
                                // if (serviceGroupRate == null) {
                                //   serviceGroupRate = {};
                                // }
                                if (serviceGroupRate != null) {
                                  workOrderLabour.initialLabourRate = serviceGroupRate.rate
                                    ? serviceGroupRate.rate
                                    : null;
                                  workOrderLabour.rate = serviceGroupRate.labourRate
                                    ? serviceGroupRate.labourRate
                                    : null;
                                  workOrderLabour.rateTypeId = serviceGroupRate.rateType
                                    ? serviceGroupRate.rateType
                                    : null;
                                  switch (action.payload.vehicle.typeId) {
                                    case 'C':
                                      workOrderLabour.subTransactionTypeId = serviceGroupRate.retailLabourCarTransTypeId
                                        ? serviceGroupRate.retailLabourCarTransTypeId
                                        : null;

                                      break;
                                    case 'M':
                                      workOrderLabour.subTransactionTypeId =
                                        serviceGroupRate.retailLabourMediumDutyTruckTransTypeId
                                          ? serviceGroupRate.retailLabourMediumDutyTruckTransTypeId
                                          : null;
                                      break;
                                    case 'L':
                                      workOrderLabour.subTransactionTypeId =
                                        serviceGroupRate.retailLabourTruckTransTypeId
                                          ? serviceGroupRate.retailLabourTruckTransTypeId
                                          : null;
                                      break;
                                    default:
                                      workOrderLabour.subTransactionTypeId = null;
                                      break;
                                  }
                                } else if (serviceTotals !== null) {
                                  console.log('HERE FOR GM PRICING');
                                  console.log(serviceTotals);

                                  workOrderLabour.initialLabourRate = serviceTotals?.serviceLabourRate
                                    ? serviceTotals?.serviceLabourRate
                                    : null;
                                  workOrderLabour.rate = serviceTotals?.serviceLabourRate
                                    ? serviceTotals?.serviceLabourRate
                                    : null;
                                  workOrderLabour.rateTypeId = serviceTotals?.rateType ? serviceTotals.rateType : null;
                                  workOrderLabour.subTotal = 0;
                                }

                                workOrderLabour.warrantyTypeId = 'L';
                                workOrderLabour.workOrderId = workOrderCase.workOrderId;
                                workOrderLabour.caseFromQuote = false;
                                workOrderLabour.caseStatusId = 'N';
                                workOrderLabour.chargeoutRateBasisId = 1;
                                workOrderLabour.creditMemo = '0';
                                workOrderLabour.estimatedTime = workOrderCase.estimatedTime
                                  ? workOrderCase.estimatedTime
                                  : null;

                                workOrderLabour.labourOp = workOrderCase.labourOp;
                                workOrderLabour.quoteFlag = action.payload.workOrder.statusId === 'Q' ? '1' : '0';

                                workOrderLabour.recommendedHours = workOrderCase.recommendedHours
                                  ? workOrderCase.recommendedHours
                                  : null;
                                workOrderLabour.serviceGroupId = workOrderCase.serviceGroupId;
                                workOrderLabour.serviceName = workOrderCase.note;
                                workOrderLabour.shopSupplyFlag = '1'; //Get asscu_shop_flag if 0 then 0. If 1 then we check sgred_shop_flag if null/''/'1' we use '1' ELSE '0'
                                if (action.payload.workOrderCase.warrantySubmissionTypeId == 'WC') {
                                  workOrderLabour.submitFlag = '1';
                                } else {
                                  workOrderLabour.submitFlag = '0';
                                }

                                workOrderLabour.technicianRateBasisId = 1;
                                workOrderLabour.warrantyCase = workOrderRequestSub.warrantyCase;
                                workOrderLabour.sequence = workOrderCase.sequence;

                                if (workOrderLabour.subTransactionTypeId == null) {
                                  workOrderLabour.subTransactionTypeId = labourRate.labourTransType;
                                }

                                switch (workOrderCase.warrantySubmissionTypeId) {
                                  case 'WC':
                                  case 'EC':
                                  case 'CC':
                                  case 'TC':
                                  case 'MM':
                                  case 'SN':
                                  case 'DP':
                                  case 'MS':
                                  case 'TW':
                                  case 'W2':
                                  case 'E2':
                                  case 'C2':
                                    workOrderLabour.warrantyTypeId = 'L';
                                    break;
                                  default:
                                    workOrderLabour.warrantyTypeId = null;
                                    break;
                                }
                                workOrderLabour.warrantySubmissionTypeId = workOrderCase.warrantySubmissionTypeId;

                                return this.apiService
                                  .post<WorkOrderLabour>(
                                    `v/1/fixed-operations/work-orders/${action.payload.workOrderCase.workOrderId}/labours`,
                                    workOrderLabour
                                  )
                                  .pipe(
                                    map((workOrderLabour) => {
                                      return new CreateWorkOrderCaseOnServerSuccess({
                                        workOrderCase: workOrderCase,
                                      });
                                    })
                                  );
                              })
                            );
                        })
                      );
                  })
                );
            })
          );
      },
      onError: (action: CreateWorkOrderCaseOnServer, error) => {
        console.error('Error', error);
      },
    })
  );

  deleteWorkOrderCaseFromServer = createEffect(() =>
    this.dataPersistence.fetch(WorkOrderCasesEntityActionTypes.DeleteWorkOrderCaseFromServer, {
      run: (action: DeleteWorkOrderCaseFromServer, state: any) => {
        return this.apiService
          .get<WorkOrderLabour>(`v/1/fixed-operations/work-orders/${action.payload.workOrderId}/labours`, {
            params: {
              serviceGroupId: action.payload.serviceGroupId,
            },
          })
          .pipe(
            map((workOrderLabours) => workOrderLabours[0]),
            switchMap((workOrderLabour: WorkOrderLabour) => {
              return this.apiService.delete<WorkOrderLabour>(
                `v/1/fixed-operations/work-orders/${action.payload.workOrderId}/labours/${workOrderLabour.id}`
              );
            }),
            switchMap((workOrderLabour: WorkOrderLabour) => {
              return this.apiService.get<WorkOrderRequestSub>(
                `v/1/fixed-operations/work-orders/${action.payload.workOrderId}/request-subs`,
                {
                  params: {
                    workOrderSequence: action.payload.sequence,
                  },
                }
              );
            }),
            map((workOrderRequestSubs) => workOrderRequestSubs[0]),
            switchMap((workOrderRequestSub: WorkOrderRequestSub) => {
              return this.apiService.delete<WorkOrderRequestSub>(
                `v/1/fixed-operations/work-orders/${action.payload.workOrderId}/request-subs/${workOrderRequestSub.id}`
              );
            }),
            switchMap((workOrderRequestSub: WorkOrderRequestSub) => {
              return this.apiService.delete<WorkOrderCase>(
                `v/1/fixed-operations/work-orders/${action.payload.workOrderId}/cases/${action.payload.id}`
              );
            }),

            map((workOrderCase) => {
              return new DeleteWorkOrderCaseFromServerSuccess(workOrderCase);
            })
          );
      },
      onError: (action: DeleteWorkOrderCaseFromServer, error) => {
        console.error('Error', error);
      },
    })
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router
  ) {}
}
